<!-- Main Content -->
<div class="container mt-4">
  <!-- Title with Icon -->
  <h1 class="h3 mb-2 text-gray-800">
    <i class="fas fa-barcode mr-2"></i>Mã Vạch
  </h1>

  <!-- Description Below Title -->
  <p class="lead mb-4">
    Quản lý và tạo mã vạch cho nhiều mục đích khác nhau. Sử dụng các tab để điều hướng giữa danh sách chi tiết mã vạch và hướng dẫn sử dụng. Nhấn "Tạo Mã Vạch" để tạo mục mới hoặc chỉnh sửa mục hiện có.
  </p>

  <!-- Navigation Tabs -->
  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a class="nav-link active" data-toggle="tab" href="#List">
        <i class="fas fa-list mr-2"></i> Danh Sách
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#UserManual">
        <i class="fas fa-book mr-2"></i> Hướng Dẫn Sử Dụng
      </a>
    </li>
  </ul>

  <!-- Tab Content -->
  <div class="tab-content">
    <!-- List tab content -->
    <div id="List" class="tab-pane fade show active">
      <div class="container-fluid">
      

        <div *ngIf="loadingIndicator; else loaded">
          <div class="d-flex justify-content-center">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Đang tải...</span>
            </div>
          </div>
        </div>
        <ng-template #loaded>
          <!-- Bar Code Table -->
          <div class="card mb-4">
            <div class="card-body">
                <!-- Button trigger modal -->
        <button class="btn btn-outline-primary mb-3" (click)="openAddDialog()">Tạo Mã Vạch</button>
        
        <button
        href="#"
        role="button"
        class="btn btn-outline-warning btn-icon-split"
        (click)="loadBarcodes()"
        >
        <span class="icon text-warning">
          <i class="fas fa-redo"></i>
        </span>
        <span class="text">Tải Lại</span>
        </button>
              <ngx-datatable
  class="bootstrap"
  [rows]="barcodes"
  [columnMode]="'force'"
  [headerHeight]="50"
  [footerHeight]="50"
  [rowHeight]="'auto'">

  <ngx-datatable-column name="ISBN" [prop]="'isbn'">
    <ng-template ngx-datatable-cell-template let-row="row">
      <span style="color: red;">{{ row.isbn }}</span>
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column *ngFor="let column of columns" [name]="column.name" [prop]="column.prop"> 
  </ngx-datatable-column>

  <ngx-datatable-column name="Hành Động">
    <ng-template ngx-datatable-cell-template let-row="row">
      <button type="button" class="btn btn-outline-primary btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Hành Động">
        <i class="fas fa-cog"></i> Hành Động
    </button>
    <div class="dropdown-menu">
      <a class="dropdown-item"  (click)="openViewDialog(row)" title="Xem">
        <i class="fas fa-eye"></i> Xem
      </a>

        <!-- <a class="dropdown-item"  (click)="openEditDialog(row)" title="Chỉnh Sửa">
            <i class="fas fa-edit"></i> Chỉnh Sửa
        </a> -->
        <a class="dropdown-item"  (click)="deleteBarCode(row.id)" title="Xóa">
            <i class="fas fa-trash"></i> Xóa
        </a>
        <a class="dropdown-item" (click)="regenerateBarCode(row)">
            <i class="fas fa-qrcode"></i> Tạo Lại Mã Vạch
        </a>
        <a class="dropdown-item" (click)="printBarCode(row)">
            <i class="fas fa-print"></i> In
        </a>
        <a class="dropdown-item" (click)="downloadBarCode(row)">
          <i class="fas fa-download"></i> Tải Xuống
      </a>
    </div>
    </ng-template>
  </ngx-datatable-column>
  
</ngx-datatable>

            </div>
          </div>
        </ng-template>
      </div>
    </div>

    <!-- User Manual tab content -->
    <div id="UserManual" class="tab-pane custom-tab-pane">
      <!-- User Manual content here -->
      <div>
         <!-- <markdown [src]="markdownContent" [data]="markdownContent"></markdown>  -->
          <div  [innerHTML]="markdownContent"></div>
      </div>
    </div>

  </div>
</div>
